/**
 * Save a tapped serving button on the open recipe.
 * The cook record picks it up when the recipe is marked cooked.
 */

export function servingChoiceConfirmation({ action, item, addedToList }) {
  const name = String(item || '').trim()
  if (action === 'add') {
    if (addedToList && name) {
      const titled = name.charAt(0).toUpperCase() + name.slice(1)
      return `${titled} is on your list. I'll remember that when you mark this cooked.`
    }
    if (name) {
      return `I'll remember that when you mark this cooked. Add ${name} to your list from Shop.`
    }
  }
  if (name) {
    return `I'll remember you used ${name} when you mark this cooked.`
  }
  return `I'll remember that when you mark this cooked.`
}

/**
 * @param {string} recipeId
 * @param {{ label?: string, servingItem?: string, servingAction?: string }} action
 * @param {typeof fetch} fetchImpl
 * @param {string} [responseActivityId]
 * @returns {Promise<{ ok: boolean, message: string, shoppingListId: string|null }>}
 */
export async function recordServingChoice(recipeId, action, fetchImpl, responseActivityId = '') {
  const fallback = { ok: false, message: "That choice didn't save. Try again.", shoppingListId: null }
  if (!recipeId || !action?.label) return fallback
  let res
  try {
    res = await fetchImpl(`/recipes/${encodeURIComponent(recipeId)}/serving-choice`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        label: action.label,
        item: action.servingItem || null,
        action: action.servingAction === 'add' ? 'add' : 'use',
        response_activity_id: responseActivityId || null,
      }),
    })
  } catch {
    return fallback
  }
  let data = {}
  try {
    data = await res.json()
  } catch {
    data = {}
  }
  if (!res.ok) return fallback
  return {
    ok: true,
    message: servingChoiceConfirmation({
      action: action.servingAction,
      item: action.servingItem,
      addedToList: Boolean(data.added_to_list),
    }),
    shoppingListId: data.shopping_list_id || null,
  }
}
